<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_xvii"><span class="line">A HISTORY OF BRITAIN</span></a></p><a id="page_xvii">
<p class="halftitlea">1945 TO BREXIT</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 11_Fm03.vue?aeb40f28